import { Component, OnInit, Input } from '@angular/core';
import { NbDialogService } from '@nebular/theme';
import { CommunicationControlComponent } from '../formats/procedure-7/communication-control/communication-control.component';
import { UnsafeConditionsComponent } from '../formats/procedure-7/unsafe-conditions/unsafe-conditions.component';

@Component({
  selector: 'ngx-actions-manager',
  templateUrl: './actions-manager.component.html',
  styleUrls: ['./actions-manager.component.scss']
})
export class ActionsManagerComponent implements OnInit {
  @Input() stationId: string;
  @Input() formatInfo: any;
  loading = false;

  constructor(
    private dialogService: NbDialogService,
  ) { }

  ngOnInit() {
  }

  getFormatForm(action: string) {
    switch (this.formatInfo.data.code) {
      case 'FOR-P7-01':
        this.showModalCreateCommunication(action)
        break;
      case 'FOR-P7-02':
        this.showModalCreateUnsafeCondition(action)
        break;
    }
  }

  async showModalCreateCommunication(action: any) {
    this.dialogService.open(CommunicationControlComponent, {
      hasScroll: true,
      context: {
        stationId: this.stationId,
        action: action
      },
    }).onClose.subscribe(response => response ? this.ngOnInit() : null);
  }

  async showModalCreateUnsafeCondition(action: any) {
    this.dialogService.open(UnsafeConditionsComponent, {
      hasScroll: true,
      context: {
        stationId: this.stationId,
        action: action
      },
    }).onClose.subscribe(response => response ? this.ngOnInit() : null);
  }

}
